import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  Box,
  Select,
  Grid,
  MenuItem,
  TextField,
  Skeleton,
  ListSubheader,
  InputAdornment,
  Typography,
  Switch,
  styled,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Radio,
  Button,
  InputBase,
  createSvgIcon,
  Checkbox,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { getUserProfile } from "../../store/reducers/userProfileReducer";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import { getUserSettingDispatch } from "./../../store/reducers/userProfileReducer";
import countryCodes from "../../utilities/countriesData";
import "./style.scss";
import StyledFilledButton from "../../components/ReusableComponents/Button";
import editIcon from "../../assets/images/editIcon.svg";
import generateIcon from "../../assets/images/generateIcon.svg";
import requestIcon from "../../assets/images/requestIcon.svg";
import deelIcon from "../../assets/images/deelIcon.svg";
import digiSignerIcon from "../../assets/icons/digiSigner-Logo.svg";
import bankWireIcon from "../../assets/images/bankWireIcon.svg";
import sumsubIcon from "../../assets/images/sumsubIcon.svg";
import veriffLogo from "../../assets/images/veriff-logos-idbWSyvHbJ.png";
// import protectIcon from "../../assets/images/accountProtection.svg";
import badgeCompleteIcon from "../../assets/images/badgeComplete.svg";
import badgeErrorIcon from "../../assets/images/badgeError.svg";
// import paymentIcon from "../../assets/images/paymentIcon.svg";
import uploadIcon from "../../assets/images/uploadIcon.svg";
import riseIcon from "../../assets/images/payment/rise.svg";
import checkbox from "../../assets/icons/checkbox.svg";
import checkboxChecked from "../../assets/icons/checkbox-checked.svg";
import wiseIcon from "../../assets/images/payment/wise-logo.svg";
import downloadIcon from "../../assets/images/download.svg";
import * as ReactBootstrap from "react-bootstrap";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import Title from "../../components/ReusableComponents/title";
import useMobile from "../../hooks/useMobile";
import RequestPayout from "./RequestPayout";
import {
  getOutstandingCommission,
  getPayoutList,
  getPayoutVerificationStatus,
  getVeriffLink,
  makeClaimRequest,
  uploadKycDoc,
} from "../../store/reducers/payoutReducer";
import BankWireModal from "./BankWireModal";
import DeelModal from "./DeelModal";
import StyledCard from "../Achievements/Card";
import { dollarUS, formatDateTime } from "../../utilities/formatters";
import { axiosInstance } from "../../Axios";
import RiseModal from "./RiseModel";
import WiseModal from "./WiseModal";
import ErrorPopup from "../../components/Popups/Error";
import CustomLoadingButton from "../../reusableComponents/CustomLoadingButton";
import Loader from "../../reusableComponents/Loader";
import AdsComponent from "../../components/AdsComponent";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import {
  BANNED_COUNTRY_CODES,
  BANNED_COUNTRY_NAMES,
} from "../../constants/bannedCountries";
import SecureBadge from "../../../src/assets/icons/secure-badge.svg"

const OpenIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2 9.174C14.0143 9.174 13.8363 9.24775 13.705 9.37902C13.5737 9.5103 13.5 9.68835 13.5 9.874V14.9C13.5 15.0857 13.4263 15.2637 13.295 15.395C13.1637 15.5263 12.9857 15.6 12.8 15.6H5.1C4.91435 15.6 4.7363 15.5263 4.60503 15.395C4.47375 15.2637 4.4 15.0857 4.4 14.9V7.2C4.4 7.01435 4.47375 6.8363 4.60503 6.70503C4.7363 6.57375 4.91435 6.5 5.1 6.5H10.126C10.3117 6.5 10.4897 6.42625 10.621 6.29497C10.7523 6.1637 10.826 5.98565 10.826 5.8C10.826 5.61435 10.7523 5.4363 10.621 5.30503C10.4897 5.17375 10.3117 5.1 10.126 5.1H5.1C4.54305 5.1 4.0089 5.32125 3.61508 5.71508C3.22125 6.1089 3 6.64305 3 7.2V14.9C3 15.457 3.22125 15.9911 3.61508 16.3849C4.0089 16.7788 4.54305 17 5.1 17H12.8C13.357 17 13.8911 16.7788 14.2849 16.3849C14.6788 15.9911 14.9 15.457 14.9 14.9V9.874C14.9 9.68835 14.8263 9.5103 14.695 9.37902C14.5637 9.24775 14.3857 9.174 14.2 9.174ZM16.944 3.434C16.873 3.26296 16.737 3.12703 16.566 3.056C16.4818 3.02013 16.3915 3.00111 16.3 3H12.1C11.9143 3 11.7363 3.07375 11.605 3.20503C11.4738 3.3363 11.4 3.51435 11.4 3.7C11.4 3.88565 11.4738 4.0637 11.605 4.19497C11.7363 4.32625 11.9143 4.4 12.1 4.4H14.613L7.403 11.603C7.33739 11.6681 7.28531 11.7455 7.24978 11.8308C7.21424 11.9161 7.19594 12.0076 7.19594 12.1C7.19594 12.1924 7.21424 12.2839 7.24978 12.3692C7.28531 12.4545 7.33739 12.5319 7.403 12.597C7.46807 12.6626 7.54549 12.7147 7.6308 12.7502C7.7161 12.7858 7.80759 12.8041 7.9 12.8041C7.99241 12.8041 8.0839 12.7858 8.1692 12.7502C8.25451 12.7147 8.33193 12.6626 8.397 12.597L15.6 5.387V7.9C15.6 8.08565 15.6737 8.2637 15.805 8.39497C15.9363 8.52625 16.1143 8.6 16.3 8.6C16.4857 8.6 16.6637 8.52625 16.795 8.39497C16.9263 8.2637 17 8.08565 17 7.9V3.7C16.9989 3.60853 16.9799 3.51816 16.944 3.434Z"
      fill="#8B8E93"
    />
  </svg>
);

const ShowPassword = () => {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM10 4.75C8.75736 4.75 7.75 5.75736 7.75 7C7.75 8.24264 8.75736 9.25 10 9.25C11.2426 9.25 12.25 8.24264 12.25 7C12.25 5.75736 11.2426 4.75 10 4.75Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.32343 5.64635C1.90431 6.25029 1.75 6.7227 1.75 7C1.75 7.2773 1.90431 7.74971 2.32343 8.35365C2.72857 8.93744 3.33078 9.57028 4.09267 10.155C5.61978 11.3271 7.71345 12.25 10 12.25C12.2865 12.25 14.3802 11.3271 15.9073 10.155C16.6692 9.57028 17.2714 8.93744 17.6766 8.35365C18.0957 7.74971 18.25 7.2773 18.25 7C18.25 6.7227 18.0957 6.25029 17.6766 5.64635C17.2714 5.06256 16.6692 4.42972 15.9073 3.84497C14.3802 2.67292 12.2865 1.75 10 1.75C7.71345 1.75 5.61978 2.67292 4.09267 3.84497C3.33078 4.42972 2.72857 5.06256 2.32343 5.64635ZM3.17941 2.65503C4.90965 1.32708 7.31598 0.25 10 0.25C12.684 0.25 15.0903 1.32708 16.8206 2.65503C17.6874 3.32028 18.4032 4.06244 18.9089 4.79115C19.4006 5.49971 19.75 6.2773 19.75 7C19.75 7.7227 19.4006 8.50029 18.9089 9.20885C18.4032 9.93756 17.6874 10.6797 16.8206 11.345C15.0903 12.6729 12.684 13.75 10 13.75C7.31598 13.75 4.90965 12.6729 3.17941 11.345C2.31262 10.6797 1.59681 9.93756 1.0911 9.20885C0.599371 8.50029 0.25 7.7227 0.25 7C0.25 6.2773 0.599371 5.49971 1.0911 4.79115C1.59681 4.06244 2.31262 3.32028 3.17941 2.65503Z"
        fill="white"
      />
    </svg>
  );
};

const HidePassword = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 1.53033C18.8232 1.23744 18.8232 0.762563 18.5303 0.46967C18.2374 0.176777 17.7626 0.176777 17.4697 0.46967L1.46967 16.4697C1.17678 16.7626 1.17678 17.2374 1.46967 17.5303C1.76256 17.8232 2.23744 17.8232 2.53033 17.5303L5.37723 14.6834C6.74353 15.3266 8.31719 15.75 10 15.75C12.684 15.75 15.0903 14.6729 16.8206 13.345C17.6874 12.6797 18.4032 11.9376 18.9089 11.2089C19.4006 10.5003 19.75 9.7227 19.75 9C19.75 8.2773 19.4006 7.49971 18.9089 6.79115C18.4032 6.06244 17.6874 5.32028 16.8206 4.65503C16.5585 4.45385 16.2808 4.25842 15.989 4.07163L18.5303 1.53033ZM14.8995 5.16113L13.1287 6.93196C13.5213 7.52478 13.75 8.23569 13.75 9C13.75 11.0711 12.0711 12.75 10 12.75C9.23569 12.75 8.52478 12.5213 7.93196 12.1287L6.51524 13.5454C7.58077 13.9795 8.76212 14.25 10 14.25C12.2865 14.25 14.3802 13.3271 15.9073 12.155C16.6692 11.5703 17.2714 10.9374 17.6766 10.3536C18.0957 9.74971 18.25 9.2773 18.25 9C18.25 8.7227 18.0957 8.25029 17.6766 7.64635C17.2714 7.06256 16.6692 6.42972 15.9073 5.84497C15.5941 5.60461 15.2571 5.37472 14.8995 5.16113ZM9.02994 11.0307C9.32366 11.1713 9.65264 11.25 10 11.25C11.2426 11.25 12.25 10.2426 12.25 9C12.25 8.65264 12.1713 8.32366 12.0307 8.02994L9.02994 11.0307Z"
        fill="white"
      />
      <path
        d="M10 2.25C11.0323 2.25 12.0236 2.40934 12.9511 2.68101C13.1296 2.73328 13.1827 2.95662 13.0513 3.0881L12.2267 3.91265C12.1648 3.97451 12.0752 3.99928 11.99 3.97967C11.3506 3.83257 10.6839 3.75 10 3.75C7.71345 3.75 5.61978 4.67292 4.09267 5.84497C3.33078 6.42972 2.72857 7.06256 2.32343 7.64635C1.90431 8.25029 1.75 8.7227 1.75 9C1.75 9.2773 1.90431 9.74971 2.32343 10.3536C2.67725 10.8635 3.18138 11.4107 3.81091 11.9307C3.92677 12.0264 3.93781 12.2015 3.83156 12.3078L3.12265 13.0167C3.03234 13.107 2.88823 13.1149 2.79037 13.0329C2.09739 12.4517 1.51902 11.8255 1.0911 11.2089C0.599371 10.5003 0.25 9.7227 0.25 9C0.25 8.2773 0.599371 7.49971 1.0911 6.79115C1.59681 6.06244 2.31262 5.32028 3.17941 4.65503C4.90965 3.32708 7.31598 2.25 10 2.25Z"
        fill="white"
      />
      <path
        d="M10 5.25C10.1185 5.25 10.2357 5.25549 10.3513 5.26624C10.5482 5.28453 10.6194 5.51991 10.4796 5.6597L9.26739 6.87196C8.61408 7.09683 8.09683 7.61408 7.87196 8.26739L6.6597 9.47965C6.51991 9.61945 6.28453 9.54818 6.26624 9.35132C6.25549 9.23566 6.25 9.11847 6.25 9C6.25 6.92893 7.92893 5.25 10 5.25Z"
        fill="white"
      />
    </svg>
  );
};

const Profile = () => {
  const dispatch = useDispatch();

  const {
    canVerify,
    payoutAccess,
    isPaymentVerified,
    isKycVerified,
    isContractIssued,
    payment,
    payout_list,
    claimStatus,
    kyc,
  } = useSelector((state) => state.payout);

  useEffect(() => {
    dispatch(getUserSettingDispatch());
    dispatch(getPayoutVerificationStatus());
  }, [dispatch]);

  const [showPopup, setShowPopup] = useState(false);
  const [combinedPUHead, setCombinedPUHead] = useState("");
  const [combinedPUBody, setCombinedPUBody] = useState("");
  const [popUpType, setPopUpType] = useState("");
  const user_profile = useSelector((state) => state.user);
  const current_account = useSelector((state) => state.user.Get_User_settings);
  const [value, setValue] = useState("1");
  const [Photo, setPhoto] = useState("");
  const [Preview, setPreview] = useState("");
  const [open, setOpen] = useState(false);
  const [sumOpen, setSumOpen] = useState(false);
  const [deelOpen, setDeelOpen] = useState(false);
  const [riseOpen, setRiseOpen] = useState(false);
  const [wiseOpen, setWiseOpen] = useState(false);
  const [sumsubRadio, setSumsubRadio] = useState("");
  const [errorPopupVisible, setErrorPopupVisible] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [claimLoading, setClaimLoading] = useState(false);

  const [requestPayout, setRequestPayout] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const [kycLoading, setKycLoading] = useState(false);

  const [processError, setProcessError] = useState({
    paymentProcess: false,
    kycProcess: false,
  });
  const [paymentTryAgain, setPaymentTryAgain] = useState(null);

  const loader = useSelector((state) => state.loader.is_loading);
  const [openLoader, setOpenLoader] = useState(loader);
  useEffect(() => {
    setOpenLoader(loader);
  }, [loader]);

  const navigate = useNavigate();
  const handleContinueClick = () => {
    console.log("Continue button clicked in parent component");
    setErrorPopupVisible(false);
  };
  useEffect(() => {
    if (isPaymentVerified && payment) {
      setRadioValue(payment.type);
    }
    if (isKycVerified) setSumsubRadio("sumsub");
  }, [isPaymentVerified, payment, isKycVerified]);

  const handleClaim = async () => {
    setClaimLoading(true);
    dispatch(makeClaimRequest())
      .then((res) => {
        navigate("/dashboard");
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          console.error(
            "Error making claim request:",
            err?.response?.data?.message
          );
          setErrorPopupVisible(true);
          setErrorMsg(err?.response?.data?.message);
        } else {
          setErrorPopupVisible(true);
          setErrorMsg("Unexpected error occured. Please try later");
        }
        setClaimLoading(false);
      });
  };

  const fileref = useRef(null);
  const handleChange = (event, newValue) => {
    event.preventDefault();
    setValue(newValue);
  };
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const handleChangeLang = (e) => {
    e.preventDefault();
    setSelectedLanguage(e.target.value);
  };

  //radio button handler for verification
  const handleRadioChange = (event) => {
    // if (isPaymentVerified || payment?.type) return;
    const { name, value } = event.target;
    setRadioValue(value);
    setPaymentTryAgain(name);
    if (event.currentTarget.id === "Bank Wire") {
      setOpen(true);
    } else if (name === "Deel") {
      setDeelOpen(true);
    } else if (event.currentTarget.id === "RISE") {
      setRiseOpen(true);
    } else if (event.currentTarget.id === "WISE") {
      setWiseOpen(true);
    }
  };
  const [timeZone, setTimeZone] = useState("UTC");
  const handleChangeTZ = (e) => {
    e.preventDefault();
    setTimeZone(e.target.value);
  };

  //country array

  const [country, setCountry] = useState("");
  const myCountryNumberCodes = countryCodes;
  const [contryCodeArray, setContryCodeArray] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const handleChangePhone = (e) => {
    e.preventDefault();
    setPhoneNumber(e.target.value);
  };

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      setPhoto(e.target.files[0]);
    }
    var file = fileref.current.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      setPreview(reader.result);
    }.bind(this);
  };

  useEffect(() => {
    setContryCodeArray([]);
    var countV = Object.keys(myCountryNumberCodes).length;
    Object.entries(myCountryNumberCodes).map((item, index) => {
      let datamap = {
        countryName: item[0],
        countryCode: item[1],
      };
      setContryCodeArray((oldArray) => [...oldArray, datamap]);
    });
    dispatch(getUserProfile());

    const apiD = {
      idToken: ACCtoken,
    };
  }, []);

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState("");
  const [searchCodeText, setSearchCodeText] = useState("");

  const displayedOptions = useMemo(
    () =>
      contryCodeArray.filter((option) => {
        console.log(option);
        if (
          BANNED_COUNTRY_NAMES.includes(
            String(option.countryName).toLowerCase()
          )
        )
          return false;
        return containsText(option.countryName, searchText);
      }),
    [searchText, contryCodeArray]
  );

  const filteredCode = useMemo(
    () =>
      contryCodeArray.filter((option) =>
        containsText(option.countryCode, searchCodeText)
      ),
    [searchCodeText, contryCodeArray]
  );

  const handleCountryCodeChange = (event) => {
    setSelectedCountryCode(event.target.value);
    const country = contryCodeArray.filter((item) => {
      return item.countryCode === event.target.value;
    });
    if (country.length) setCountry(country[0].countryName);
  };

  useEffect(() => {
    const countryCode = contryCodeArray.filter((item) => {
      return item.countryName === country;
    });
    if (countryCode.length) setSelectedCountryCode(countryCode[0].countryCode);
  }, [country, contryCodeArray]);

  const handleSelectChange = (event) => {
    setCountry(event.target.value);
  };

  const [firstname, setFirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");

  const handleChangeFirstname = (event) => {
    event.preventDefault();
    setFirstname(event.target.value);
  };

  const handleChangeLastname = (event) => {
    event.preventDefault();
    setlastname(event.target.value);
  };

  const handleChangeEmail = (event) => {
    event.preventDefault();
    setEmail(event.target.value);
  };

  const handleChangeCity = (event) => {
    event.preventDefault();
    setCity(event.target.value);
  };
  const ACCtoken = useSelector((state) => state.ACCtoken);

  useEffect(() => {
    if (Object.keys(user_profile).length) {
      const {
        full_name,
        photo,
        Contact_number,
        Email,
        City,
        Country,
        first_name,
        last_name,
      } = user_profile;
      if (full_name) {
        setFirstname(first_name);
        setlastname(last_name);
      }
      // photo && setProfilePic(photo)
      photo && setPhoto(photo);
      Contact_number &&
        setPhoneNumber(
          Contact_number.slice(
            Contact_number.length - 10,
            Contact_number.length
          )
        );

      Email && setEmail(Email);
      City && setCity(City);
      Country && setCountry(Country);
    }
  }, [user_profile]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      firstname === "" ||
      lastname === "" ||
      phoneNumber === "" ||
      country === "" ||
      city === ""
    ) {
      setShowPopup(true);
      setPopUpType("error");
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Please fill all the fields");
      return;
    } else if (firstname.length < 3) {
      setShowPopup(true);
      setPopUpType("error");
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("First name is too small");
      return;
    } else if (lastname.length < 1) {
      setShowPopup(true);
      setPopUpType("error");
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Last name is too small");
      return;
    }

    let form_data = new FormData();
    if (typeof Photo === "object") {
      form_data.append("photo", Photo, Photo["name"]);
    }
    form_data.append("full_name", `${firstname} ${lastname}`);
    form_data.append("Contact_number", phoneNumber);
    form_data.append("Country", country);
    form_data.append("City", city);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    config.headers["AUTHORIZATION"] = ACCtoken;
    axiosInstance
      .post("v2/user/profile/create/", form_data, config)
      .then((res) => {
        setShowPopup(true);
        setPopUpType("success");
        setCombinedPUHead("Woo hoo !");
        setCombinedPUBody("Profile Updated Successfully");
        dispatch(getUserProfile());
      })
      .catch(function (error) {
        console.log(error);
        setShowPopup(true);
        setPopUpType("error");
        setCombinedPUHead("Oh snap!");
        setCombinedPUBody("Something went wrong");
      });
  };

  useEffect(() => {
    if (current_account && Object.keys(current_account).length) {
      setEmail(current_account.user_name);
      setSelectedLanguage(current_account.Language);
      setTimeZone(current_account.Time_Zone);
    }
  }, [current_account]);

  const handleAccountSubmit = (e) => {
    e.preventDefault();

    const UserAcc = {
      user_name: email,
      Language: selectedLanguage,
    };
    axiosInstance.post("v2/user/settings/", UserAcc).then((res) => {
      setShowPopup(true);
      setPopUpType("success");
      setCombinedPUHead("Woo hoo !");
      setCombinedPUBody("Profile Updated Successfully!");
      return;
    });
  };

  const [passwordEye, setPasswordEye] = useState(false);
  const handlePasswordClick = () => {
    setPasswordEye(!passwordEye);
  };
  const [passwordEyeVerify, setPasswordEyeVerify] = useState(false);
  const handlePasswordVerifyClick = () => {
    setPasswordEyeVerify(!passwordEyeVerify);
  };
  const [passwordEyeNew, setPasswordEyeNew] = useState(false);
  const handlePasswordNewClick = () => {
    setPasswordEyeNew(!passwordEyeNew);
  };
  const [newpassword, setCewpassword] = useState();
  const handleChangePasswordNew = (e) => {
    e.preventDefault();
    setCewpassword(e.target.value);
  };

  const [confnewpassword, setConfnewpassword] = useState();
  const handleChangePasswordNewConf = (e) => {
    e.preventDefault();
    setConfnewpassword(e.target.value);
  };

  const [passwordold, setPasswordold] = useState();
  const handleChangePasswordOld = (e) => {
    e.preventDefault();
    setPasswordold(e.target.value);
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();
    if (newpassword === "" || confnewpassword === "" || passwordold === "") {
      setShowPopup(true);
      setPopUpType("error");
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Please fill all the fields");
      return;
    } else if (newpassword !== confnewpassword) {
      setShowPopup(true);
      setPopUpType("error");
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Cant verify! New password does not match");
      return;
    }

    const passdata = {
      current_password: passwordold,
      new_password: newpassword,
      confirm_password: confnewpassword,
      idToken: ACCtoken,
    };
    axiosInstance
      .post("change/password/", passdata)
      .then((res) => {
        setShowPopup(true);
        setPopUpType("success");
        setCombinedPUHead("Oh snap!");
        setCombinedPUBody(res.data.message);
        window.location.reload();
        return;
      })
      .catch(function (error) {
        if (error.response.data?.message) {
          setShowPopup(true);
          setPopUpType("error");
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody(error.response.data.message);
        } else if (error.response.data?.detail) {
          setShowPopup(true);
          setPopUpType("error");
          setCombinedPUHead("Oh snap!");
          setCombinedPUBody(error.response.data.detail);
        }
        console.log(error);
      });
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 50,
    height: 25,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(23px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#04D9FF" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#04D9FF",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  // verificationbModal handler
  const handleClose = () => {
    setOpen(false);
    setProcessError((prev) => ({ ...prev, paymentProcess: true }));
  };

  const getKYCLink = (retry = false) => {
    setKycLoading(true);
    dispatch(getVeriffLink(retry))
      .then((res) => {
        setKycLoading(false);
        if (res.verification) {
          window.location.href = res.verification.url;
        }
      })
      .catch((err) => {
        setKycLoading(false);
        console.log(err);
      });
  };

  // Deel Modal handler
  const deelHandleOpen = () => setDeelOpen(true);
  const deelHandleClose = () => {
    setDeelOpen(false);
    setProcessError((prev) => ({ ...prev, paymentProcess: true }));
  };

  //Rise Modal handler
  const riseHandleOpen = () => setRiseOpen(true);
  const riseHandleClose = () => {
    setRiseOpen(false);
    setProcessError((prev) => ({ ...prev, paymentProcess: true }));
  };

  // WISE modal handler
  const wiseHandleClose = () => {
    setWiseOpen(false);
    setProcessError((prev) => ({ ...prev, paymentProcess: true }));
  };

  const StatFormatter = (data) => {
    const Stat = data.toLowerCase();

    const classList =
      Stat === "approved"
        ? "StatusPassed"
        : Stat === "in progress"
        ? "StatusInProgress"
        : "rejected";

    return <div className={`Status ${classList}`}>{data}</div>;
  };
  const isMobile = useMobile();

  const SelectTable = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      position: "relative",
      fontSize: 16,
      // padding: "10px",
      "&:focus": {},
    },
  }));

  // Uplaod file
  const KycUpload = ({ data }) => {
    const [dragging, setDragging] = useState(false);
    const dispatch = useDispatch();

    const handleDrag = (e) => {
      e.preventDefault();
      // e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragging(true);
      } else if (e.type === "dragleave") {
        setDragging(false);
      }
    };

    const handleDrop = (e) => {
      e.preventDefault();
      setDragging(false);

      const form_data = new FormData();
      form_data.append("file", e.dataTransfer.files[0]);
      dispatch(uploadKycDoc(form_data)).then((res) => {
        setShowPopup(true);
        setPopUpType("success");
        setCombinedPUHead("Woo hoo!");
        setCombinedPUBody("Your document was uploaded successfully!");
      });
    };

    const handleUpload = (e) => {
      const form_data = new FormData();
      form_data.append("file", e.target.files[0]);
      dispatch(uploadKycDoc(form_data)).then((res) => {
        setShowPopup(true);
        setPopUpType("success");
        setCombinedPUHead("Woo hoo!");
        setCombinedPUBody("Your document was uploaded successfully!");
      });
    };

    // const handleDelete = (id) => {
    //   dispatch(deleteKYC(id));
    // };

    return (
      <Grid item xs={12}>
        {data ? (
          <StyledCard className="kyc">
            <table className="file-list">
              <thead>
                <th></th>
                <th></th>
                <th></th>
              </thead>
              <tbody>
                <tr>
                  <td className="file-name" title={data["document"]}>
                    {data["document"]}
                  </td>
                  {/* <td className="file-actions delete">
                    <DeleteIcon onClick={(e) => handleDelete(data["id"])} />
                  </td> */}
                  <td className="file-actions open">
                    <a
                      href={data["document"]}
                      style={{ textDecoration: "none" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <OpenIcon />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </StyledCard>
        ) : (
          <StyledCard
            className="kyc"
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
          >
            <div className="upload-docs">
              {/* <div className="plchld">
                <KycFile viewBox="0 0 75 75" />
                <span>Upload file</span>
              </div> */}
              <img src={uploadIcon} alt="" className="upload-icon" />
              <div>
                Drag & Drop Or{" "}
                <label htmlFor="upload-doc" className="link">
                  Choose file
                </label>{" "}
                to Upload
              </div>
              <input type="file" onChange={handleUpload} id="upload-doc" />
            </div>
          </StyledCard>
        )}
      </Grid>
    );
  };

  // const PayoutTabs = ({canVerify, payoutAccess}) => {
  //   if(canVerify)
  //     return (

  //     );
  //   return false;

  // }

  const [profileActive, setProfileActive] = useState(1);
  const [mainTabination, setMainTabination] = useState(1);

  useEffect(() => {
    if (mainTabination === 3) {
      dispatch(getPayoutList());
      dispatch(getOutstandingCommission());
    }
  }, [dispatch, mainTabination]);

  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="PageContainer" style={{ position: "relative" }}>
      <Loader open={openLoader} />
      <CombinedPopup
        type={popUpType}
        trigger={showPopup}
        setTrigger={setShowPopup}
        head={combinedPUHead}
        subhead={combinedPUBody}
      />
      <Box
        className="ContainerTab profile-page-wrapper"
        sx={{ width: "100%" }}
        p={3}
      >
        <div className="newTabination myprofile-tabination">
          <div
            onClick={() => {
              setMainTabination(1);
            }}
            className={
              "newTabination-item " + (mainTabination === 1 && " active ")
            }
          >
            <div className="svg-con">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17C12.75 16.5858 12.4142 16.25 12 16.25V17.75ZM4 16.25C3.58579 16.25 3.25 16.5858 3.25 17C3.25 17.4142 3.58579 17.75 4 17.75L4 16.25ZM12 6.25C11.5858 6.25 11.25 6.58579 11.25 7C11.25 7.41421 11.5858 7.75 12 7.75V6.25ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM12 16.25L4 16.25L4 17.75L12 17.75V16.25ZM12 7.75L20 7.75V6.25L12 6.25V7.75ZM3.25 7C3.25 8.51878 4.48122 9.75 6 9.75V8.25C5.30964 8.25 4.75 7.69036 4.75 7H3.25ZM6 9.75C7.51878 9.75 8.75 8.51878 8.75 7H7.25C7.25 7.69036 6.69036 8.25 6 8.25V9.75ZM8.75 7C8.75 5.48122 7.51878 4.25 6 4.25V5.75C6.69036 5.75 7.25 6.30964 7.25 7H8.75ZM6 4.25C4.48122 4.25 3.25 5.48122 3.25 7H4.75C4.75 6.30964 5.30964 5.75 6 5.75V4.25ZM20.75 17C20.75 15.4812 19.5188 14.25 18 14.25V15.75C18.6904 15.75 19.25 16.3096 19.25 17H20.75ZM18 14.25C16.4812 14.25 15.25 15.4812 15.25 17H16.75C16.75 16.3096 17.3096 15.75 18 15.75V14.25ZM15.25 17C15.25 18.5188 16.4812 19.75 18 19.75V18.25C17.3096 18.25 16.75 17.6904 16.75 17H15.25ZM18 19.75C19.5188 19.75 20.75 18.5188 20.75 17H19.25C19.25 17.6904 18.6904 18.25 18 18.25V19.75Z"
                  fill="#E6FBFF"
                />
              </svg>
            </div>
            General Information
          </div>
          {canVerify && (
            <>
              {" "}
              <div
                onClick={() => {
                  setMainTabination(2);
                }}
                className={
                  "newTabination-item " + (mainTabination === 2 && " active ")
                }
              >
                <div className="svg-con">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="verification-tab-icon"
                  >
                    <path
                      d="M17 9L13.6308 12.7632C12.2957 14.2544 11.6282 15 10.75 15C9.8718 15 9.20425 14.2544 7.86917 12.7632L7 11.7924M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                      stroke="#E6FBFF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                Verification
              </div>
            </>
          )}
          {payoutAccess && (
            <>
              <div
                onClick={() => {
                  setMainTabination(3);
                }}
                className={
                  "newTabination-item " + (mainTabination === 3 && " active ")
                }
              >
                <div className="svg-con">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.38766 21.2632L4.77953 20.6237L4.38766 21.2632ZM2.73695 19.6125L3.37643 19.2206H3.37643L2.73695 19.6125ZM21.2634 19.6125L20.6239 19.2206L21.2634 19.6125ZM19.6126 21.2632L19.2208 20.6237L19.6126 21.2632ZM19.6126 5.7368L19.2208 6.37628L19.6126 5.7368ZM21.2634 7.38751L20.6239 7.77938L21.2634 7.38751ZM4.38766 5.7368L4.77953 6.37628H4.77953L4.38766 5.7368ZM2.73695 7.38751L3.37643 7.77938H3.37643L2.73695 7.38751ZM18.4769 2.54645L19.0182 2.02728V2.02728L18.4769 2.54645ZM3.84437 2.89079L4.29721 3.48865V3.48865L3.84437 2.89079ZM2.85459 3.92267L3.46991 4.35148L2.85459 3.92267ZM19.0002 5.13032H19.7502L19.7501 5.12662L19.0002 5.13032ZM18.3638 13.6137C18.778 13.6137 19.1138 13.2779 19.1138 12.8637C19.1138 12.4494 18.778 12.1137 18.3638 12.1137V13.6137ZM15.6365 12.1137C15.2223 12.1137 14.8865 12.4494 14.8865 12.8637C14.8865 13.2779 15.2223 13.6137 15.6365 13.6137V12.1137ZM10.5002 5.75H13.5002V4.25H10.5002V5.75ZM13.5002 21.25H10.5002V22.75H13.5002V21.25ZM10.5002 21.25C8.84891 21.25 7.66315 21.2492 6.73824 21.1613C5.82449 21.0744 5.24306 20.9078 4.77953 20.6237L3.99578 21.9027C4.7346 22.3554 5.57271 22.5572 6.59626 22.6545C7.60865 22.7508 8.87796 22.75 10.5002 22.75V21.25ZM1.25015 13.5C1.25015 15.1222 1.24936 16.3915 1.34562 17.4039C1.44294 18.4274 1.64472 19.2655 2.09747 20.0044L3.37643 19.2206C3.09238 18.7571 2.92576 18.1757 2.83888 17.2619C2.75094 16.337 2.75015 15.1512 2.75015 13.5H1.25015ZM4.77953 20.6237C4.20767 20.2733 3.72687 19.7925 3.37643 19.2206L2.09747 20.0044C2.57159 20.7781 3.22209 21.4286 3.99578 21.9027L4.77953 20.6237ZM13.5002 22.75C15.1223 22.75 16.3917 22.7508 17.404 22.6545C18.4276 22.5572 19.2657 22.3554 20.0045 21.9027L19.2208 20.6237C18.7572 20.9078 18.1758 21.0744 17.2621 21.1613C16.3371 21.2492 15.1514 21.25 13.5002 21.25V22.75ZM20.6239 19.2206C20.2734 19.7925 19.7926 20.2733 19.2208 20.6237L20.0045 21.9027C20.7782 21.4286 21.4287 20.7781 21.9028 20.0044L20.6239 19.2206ZM19.2208 6.37628C19.7926 6.72672 20.2734 7.20752 20.6239 7.77938L21.9028 6.99563C21.4287 6.22194 20.7782 5.57144 20.0045 5.09732L19.2208 6.37628ZM10.5002 4.25C8.87796 4.25 7.60865 4.24921 6.59626 4.34547C5.57271 4.44279 4.7346 4.64457 3.99578 5.09732L4.77953 6.37628C5.24306 6.09223 5.82449 5.92561 6.73824 5.83873C7.66315 5.75079 8.84891 5.75 10.5002 5.75V4.25ZM2.75015 13.5C2.75015 11.8488 2.75094 10.663 2.83888 9.73809C2.92576 8.82434 3.09238 8.24291 3.37643 7.77938L2.09747 6.99563C1.64472 7.73445 1.44294 8.57256 1.34562 9.59611C1.24936 10.6085 1.25015 11.8778 1.25015 13.5H2.75015ZM3.99578 5.09732C3.22209 5.57144 2.57159 6.22194 2.09747 6.99563L3.37643 7.77938C3.72687 7.20752 4.20767 6.72672 4.77953 6.37628L3.99578 5.09732ZM10.0532 2.75H15.4219V1.25H10.0532V2.75ZM15.4219 2.75C16.2876 2.75 16.8583 2.75173 17.2815 2.81105C17.6798 2.86687 17.8347 2.96039 17.9357 3.06562L19.0182 2.02728C18.595 1.58606 18.066 1.40635 17.4897 1.32557C16.9382 1.24827 16.2435 1.25 15.4219 1.25V2.75ZM10.0532 1.25C8.39302 1.25 7.08509 1.24888 6.04743 1.36609C4.99381 1.4851 4.12984 1.7337 3.39153 2.29293L4.29721 3.48865C4.73494 3.15709 5.29779 2.9603 6.21579 2.85661C7.14974 2.75112 8.35822 2.75 10.0532 2.75V1.25ZM2.75015 10.3956C2.75015 8.63063 2.7511 7.36468 2.85294 6.38472C2.9535 5.41704 3.14565 4.81679 3.46991 4.35148L2.23928 3.49385C1.7091 4.25462 1.47402 5.14188 1.36097 6.22968C1.2492 7.3052 1.25015 8.6627 1.25015 10.3956H2.75015ZM3.39153 2.29293C2.94821 2.62872 2.5596 3.03422 2.23928 3.49385L3.46991 4.35148C3.70149 4.01918 3.98091 3.72823 4.29721 3.48865L3.39153 2.29293ZM19.7501 5.12662C19.7468 4.44995 19.7324 3.86358 19.6476 3.37747C19.5596 2.87228 19.3855 2.41025 19.0182 2.02728L17.9357 3.06562C18.029 3.16295 18.1132 3.30988 18.1699 3.63506C18.2299 3.97932 18.2468 4.44473 18.2502 5.13403L19.7501 5.12662ZM1.25015 10.3956C1.25015 11.3713 1.22999 12.2642 1.25041 13.0202L2.74986 12.9798C2.7301 12.2482 2.75015 11.424 2.75015 10.3956H1.25015ZM21.5001 14.8409H15.6365V16.3409H21.5001V14.8409ZM12.1592 12.8637C12.1592 14.7841 13.7161 16.3409 15.6365 16.3409V14.8409C14.5445 14.8409 13.6592 13.9557 13.6592 12.8637H12.1592ZM13.6592 12.8637C13.6592 11.7716 14.5445 10.8864 15.6365 10.8864V9.38638C13.7161 9.38638 12.1592 10.9432 12.1592 12.8637H13.6592ZM18.3638 12.1137H15.6365V13.6137H18.3638V12.1137ZM13.5002 5.75C14.8848 5.75 15.9451 5.75032 16.8037 5.8033C17.6614 5.85623 18.2611 5.95942 18.7339 6.13895L19.2664 4.73667C18.5863 4.47839 17.8121 4.36267 16.896 4.30615C15.9808 4.24968 14.8675 4.25 13.5002 4.25V5.75ZM18.7339 6.13895C18.9109 6.20619 19.0712 6.2846 19.2208 6.37628L20.0045 5.09732C19.7711 4.95427 19.5262 4.83534 19.2664 4.73667L18.7339 6.13895ZM18.2502 5.13032V5.43781H19.7502V5.13032H18.2502ZM15.6365 10.8864H21.9446V9.38638H15.6365V10.8864ZM22.7502 13.5C22.7502 12.1255 22.7505 11.0077 22.6931 10.0896L21.196 10.1832C21.2498 11.0439 21.2502 12.108 21.2502 13.5H22.7502ZM22.6931 10.0896C22.6147 8.83476 22.4249 7.84749 21.9028 6.99563L20.6239 7.77938C20.9528 8.3161 21.1225 9.00707 21.196 10.1832L22.6931 10.0896ZM21.2502 13.5C21.2502 14.2875 21.2501 14.9722 21.2401 15.5785L22.7399 15.6034C22.7502 14.9821 22.7502 14.2839 22.7502 13.5H21.2502ZM21.2401 15.5785C21.2075 17.537 21.0636 18.5031 20.6239 19.2206L21.9028 20.0044C22.583 18.8944 22.7079 17.5313 22.7399 15.6034L21.2401 15.5785ZM21.5001 16.3409H21.99V14.8409H21.5001V16.3409Z"
                      fill="#E6FBFF"
                    />
                  </svg>
                </div>
                Payout
              </div>
            </>
          )}
        </div>

        {mainTabination === 1 && (
          <div className="ProfilePageWhole">
            <div className="profilePageLeft">
              <div className="profileTabination">
                <div
                  onClick={() => setProfileActive(1)}
                  className={
                    "profileTabination-item " +
                    (profileActive === 1 && " active ")
                  }
                >
                  {" "}
                  <div className="svgCon">
                    <svg
                      width="16"
                      height="21"
                      viewBox="0 0 16 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.25 5C11.25 6.79493 9.79493 8.25 8 8.25V9.75C10.6234 9.75 12.75 7.62335 12.75 5H11.25ZM8 8.25C6.20507 8.25 4.75 6.79493 4.75 5H3.25C3.25 7.62335 5.37665 9.75 8 9.75V8.25ZM4.75 5C4.75 3.20507 6.20507 1.75 8 1.75V0.25C5.37665 0.25 3.25 2.37665 3.25 5H4.75ZM8 1.75C9.79493 1.75 11.25 3.20507 11.25 5H12.75C12.75 2.37665 10.6234 0.25 8 0.25V1.75ZM5 12.75H11V11.25H5V12.75ZM11 19.25H5V20.75H11V19.25ZM5 19.25C3.20507 19.25 1.75 17.7949 1.75 16H0.25C0.25 18.6234 2.37665 20.75 5 20.75V19.25ZM14.25 16C14.25 17.7949 12.7949 19.25 11 19.25V20.75C13.6234 20.75 15.75 18.6234 15.75 16H14.25ZM11 12.75C12.7949 12.75 14.25 14.2051 14.25 16H15.75C15.75 13.3766 13.6234 11.25 11 11.25V12.75ZM5 11.25C2.37665 11.25 0.25 13.3766 0.25 16H1.75C1.75 14.2051 3.20507 12.75 5 12.75V11.25Z"
                        fill="#04D9FF"
                      />
                    </svg>
                  </div>{" "}
                  My Profile
                </div>
                <div
                  onClick={() => setProfileActive(2)}
                  className={
                    "profileTabination-item " +
                    (profileActive === 2 && " active ")
                  }
                >
                  {" "}
                  <div className="svgCon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="keySvg"
                    >
                      <path
                        d="M17 14L17.0528 13.8944C17.3343 13.3314 17.3343 12.6686 17.0528 12.1056V12.1056C17.0204 12.0409 16.9543 12 16.882 12L11 12H10.923M14 14L14.0528 13.8944C14.3343 13.3314 14.3343 12.6686 14.0528 12.1056L14 12M10.923 12C10.923 11.8739 10.8991 11.7478 10.8514 11.6286L10.4514 10.6286C10.2996 10.249 9.93187 10 9.52297 10H8C7.44772 10 7 10.4477 7 11V13C7 13.5523 7.44772 14 8 14H9.52297C9.93187 14 10.2996 13.751 10.4514 13.3714L10.8514 12.3714C10.8991 12.2522 10.923 12.1261 10.923 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                        stroke="#8F8F8F"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>{" "}
                  Password
                </div>
                <div
                  onClick={() => setProfileActive(3)}
                  className={
                    "profileTabination-item " +
                    (profileActive === 3 && " active ")
                  }
                >
                  {" "}
                  <div className="svgCon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.93188 5.38691L5.74952 6.1144L5.93188 5.38691ZM9.30644 3.43861L8.58523 3.23279L9.30644 3.43861ZM3.23837 10.0522L3.77722 9.53053L3.23837 10.0522ZM3.23837 13.9488L2.69952 13.4271H2.69952L3.23837 13.9488ZM5.93188 18.6141L6.11423 19.3416L5.93188 18.6141ZM9.30644 20.5624L8.58523 20.7682L9.30644 20.5624ZM14.6935 20.5624L15.4147 20.7682L14.6935 20.5624ZM18.068 18.6141L18.2504 17.8866L18.068 18.6141ZM20.7615 13.9488L20.2227 14.4705V14.4705L20.7615 13.9488ZM20.7615 10.0522L20.2227 9.53053V9.53053L20.7615 10.0522ZM18.068 5.38691L17.8857 4.65942L18.068 5.38691ZM14.6935 3.43861L15.4147 3.23279L14.6935 3.43861ZM5.74952 6.1144C7.60843 6.58036 9.50172 5.48727 10.0276 3.64443L8.58523 3.23279C8.28146 4.29719 7.18792 4.92855 6.11423 4.65942L5.74952 6.1144ZM3.77722 9.53053C2.34195 8.048 3.74798 5.61269 5.74952 6.1144L6.11423 4.65942C2.6489 3.79079 0.214599 8.00712 2.69952 10.5739L3.77722 9.53053ZM3.77722 14.4705C5.1102 13.0936 5.1102 10.9074 3.77722 9.53053L2.69952 10.5739C3.46944 11.3691 3.46944 12.6319 2.69952 13.4271L3.77722 14.4705ZM5.74952 17.8866C3.74798 18.3883 2.34195 15.953 3.77722 14.4705L2.69952 13.4271C0.214598 15.9939 2.6489 20.2102 6.11423 19.3416L5.74952 17.8866ZM10.0276 20.3566C9.50172 18.5137 7.60843 17.4207 5.74952 17.8866L6.11423 19.3416C7.18792 19.0725 8.28146 19.7038 8.58523 20.7682L10.0276 20.3566ZM13.9722 20.3566C13.406 22.3408 10.5939 22.3408 10.0276 20.3566L8.58523 20.7682C9.56564 24.2036 14.4342 24.2036 15.4147 20.7682L13.9722 20.3566ZM18.2504 17.8866C16.3915 17.4207 14.4982 18.5137 13.9722 20.3566L15.4147 20.7682C15.7184 19.7038 16.812 19.0725 17.8857 19.3416L18.2504 17.8866ZM20.2227 14.4705C21.6579 15.953 20.2519 18.3883 18.2504 17.8866L17.8857 19.3416C21.351 20.2102 23.7853 15.9939 21.3004 13.4271L20.2227 14.4705ZM20.2227 9.53053C18.8897 10.9074 18.8897 13.0936 20.2227 14.4705L21.3004 13.4271C20.5305 12.6319 20.5305 11.3691 21.3004 10.5739L20.2227 9.53053ZM18.2504 6.1144C20.2519 5.61269 21.6579 8.048 20.2227 9.53053L21.3004 10.5739C23.7853 8.00712 21.351 3.79079 17.8857 4.65942L18.2504 6.1144ZM13.9722 3.64443C14.4982 5.48727 16.3915 6.58036 18.2504 6.1144L17.8857 4.65942C16.812 4.92855 15.7184 4.29719 15.4147 3.23279L13.9722 3.64443ZM15.4147 3.23279C14.4342 -0.202596 9.56564 -0.202595 8.58523 3.23279L10.0276 3.64443C10.5939 1.66019 13.406 1.66019 13.9722 3.64443L15.4147 3.23279ZM8.24994 12.0005C8.24994 14.0716 9.92888 15.7505 11.9999 15.7505V14.2505C10.7573 14.2505 9.74994 13.2431 9.74994 12.0005H8.24994ZM11.9999 15.7505C14.071 15.7505 15.7499 14.0716 15.7499 12.0005H14.2499C14.2499 13.2431 13.2426 14.2505 11.9999 14.2505V15.7505ZM15.7499 12.0005C15.7499 9.92944 14.071 8.2505 11.9999 8.2505V9.7505C13.2426 9.7505 14.2499 10.7579 14.2499 12.0005H15.7499ZM11.9999 8.2505C9.92888 8.2505 8.24994 9.92944 8.24994 12.0005H9.74994C9.74994 10.7579 10.7573 9.7505 11.9999 9.7505V8.2505Z"
                        fill="#8F8F8F"
                      />
                    </svg>
                  </div>{" "}
                  Account Setting
                </div>
              </div>
            </div>
            <div className="profilePageRight">
              {" "}
              {profileActive === 1 && (
                <div className="DpboxCon">
                  <div className="DpboxCon-Top myp">
                    <div className="profileTop-c">
                      My Profile
                      <div className="profileTop-c-bt">
                        <div
                          className="profileTop-c-bt-l"
                          style={{
                            position: "relative",
                            width: "60px",
                            height: "60px",
                          }}
                        >
                          {Preview ? (
                            <img
                              src={Preview}
                              alt="pImg"
                              width={60}
                              height={60}
                              style={{ borderRadius: "50%" }}
                            />
                          ) : Photo ? (
                            <img
                              src={Photo}
                              alt="pImg"
                              width={60}
                              height={60}
                              style={{ borderRadius: "50%" }}
                            />
                          ) : (
                            <Skeleton
                              sx={{ bgcolor: "#222c3a" }}
                              animation={
                                Object.keys(user_profile).length && false
                              }
                              variant="circular"
                              width={60}
                              height={60}
                              style={{
                                width: "60px",
                                height: "60px",
                                position: "absolute",
                                zIndex: 8,
                              }}
                            />
                          )}
                          <input
                            type="file"
                            name="photo"
                            ref={fileref}
                            onChange={handleFileUpload}
                            style={{
                              position: "absolute",
                              left: 0,
                              width: "60px",
                              height: "60px",
                              zIndex: 10,
                              opacity: 0,
                              borderRadius: "50%",
                            }}
                          />
                          <img
                            src={editIcon}
                            alt="editIcon"
                            style={{
                              position: "absolute",
                              bottom: "2%",
                              right: "2%",
                              zIndex: "10",
                            }}
                          />
                        </div>

                        <div className="profileTop-c-bt-r">
                          <h3>
                            {firstname || lastname ? (
                              `${firstname} ${lastname}`
                            ) : (
                              <Skeleton
                                sx={{ bgcolor: "#222c3a" }}
                                animation={
                                  !Object.keys(user_profile).length && true
                                }
                                variant="text"
                                width={80}
                              ></Skeleton>
                            )}
                          </h3>
                          <h4>{email}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Grid
                    container
                    item
                    onSubmit={handleSubmit}
                    className="gen-info-form"
                    component={"form"}
                    spacing={3}
                  >
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="first-name">
                          First Name
                        </Typography>
                        <input
                          type="text"
                          className="input-acg"
                          value={firstname}
                          id="first-name"
                          onChange={handleChangeFirstname}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="last-name">
                          Last Name
                        </Typography>
                        <input
                          type="text"
                          value={lastname}
                          id="last-name"
                          className="input-acg"
                          onChange={handleChangeLastname}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="phoneNumber">
                          Contact Number
                        </Typography>
                        <div className="phoneCON">
                          <div>
                            <Select
                              className="form-input-select-countryCode"
                              value={selectedCountryCode}
                              label="CountryCode"
                              // disabled={true}
                              onChange={handleCountryCodeChange}
                              onClose={() => setSearchCodeText("")}
                              MenuProps={{ autoFocus: false }}
                              sx={{ color: "#fff" }}
                              style={{ color: "#fff" }}
                            >
                              <ListSubheader>
                                <TextField
                                  size="small"
                                  autoFocus
                                  placeholder="Type to search..."
                                  fullWidth
                                  sx={{ color: "white" }}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start"></InputAdornment>
                                    ),
                                  }}
                                  onChange={(e) =>
                                    setSearchCodeText(e.target.value)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key !== "Escape") {
                                      // Prevents autoselecting item while typing (default Select behaviour)
                                      e.stopPropagation();
                                    }
                                  }}
                                />
                              </ListSubheader>
                              {filteredCode.map((country, index) => {
                                if (
                                  country.countryCode === "+1" ||
                                  country.countryCode === "1"
                                )
                                  return false;
                                return (
                                  <MenuItem
                                    key={index}
                                    value={country.countryCode}
                                  >
                                    {country.countryCode}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </div>
                          <div className="spacerBTMR20"></div>
                          <input
                            id="phoneNumber"
                            type={"number"}
                            name="phoneNumber"
                            className="form-input-text input-acg"
                            value={phoneNumber}
                            onChange={handleChangePhone}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="email">
                          Email
                        </Typography>
                        <input
                          type="text"
                          className="input-acg"
                          id="email"
                          value={email}
                          disabled
                          onChange={handleChangeEmail}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography
                          component={"label"}
                          htmlFor="country-select"
                        >
                          Country
                        </Typography>
                        <Select
                          id="country-select"
                          className="form-input-select"
                          value={country}
                          onChange={handleSelectChange}
                          MenuProps={{ autoFocus: false }}
                          labelId="search-select-label"
                          onClose={() => setSearchText("")}
                          renderValue={() => country}
                        >
                          <ListSubheader>
                            <TextField
                              size="small"
                              // Autofocus on textfield
                              autoFocus
                              placeholder="Type to search..."
                              fullWidth
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start"></InputAdornment>
                                ),
                              }}
                              onChange={(e) => setSearchText(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  // Prevents autoselecting item while typing (default Select behaviour)
                                  e.stopPropagation();
                                }
                              }}
                            />
                          </ListSubheader>
                          {displayedOptions.map((country, index) => {
                            if (BANNED_COUNTRY_CODES.includes(country.code))
                              return false;
                            return (
                              <MenuItem key={index} value={country.countryName}>
                                {country.countryName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="city">
                          City
                        </Typography>
                        <input
                          type="text"
                          className="input-acg"
                          id="city"
                          value={city}
                          onChange={handleChangeCity}
                        />
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <StyledFilledButton
                      sx={{ marginLeft: "", marginTop: "20px" }}
                      type="submit"
                      onClick={handleSubmit}
                      className="myprofile-button"
                    >
                      Save changes
                    </StyledFilledButton>
                  </Grid>
                </div>
              )}
              {/* Change Password Starts here */}
              {profileActive === 2 && (
                <div className="DpboxCon">
                  <div className="DpboxCon-Top myp">
                    <div className="profileTop-c">Password</div>
                  </div>
                  <Grid
                    onSubmit={handleSubmitPassword}
                    className="gen-info-form"
                    component={"form"}
                    container
                    spacing={3}
                  >
                    <Grid item md={4}>
                      <div className="form-grp-in">
                        <Typography
                          xs={12}
                          md={4}
                          component={"label"}
                          htmlFor="cur-password"
                          width={"100% !important"}
                        >
                          Current Password
                        </Typography>
                        <div className="ProfilePasswordEye">
                          <input
                            className="input-acg"
                            type={passwordEye === false ? "password" : "text"}
                            value={passwordold}
                            id="cur-password"
                            onChange={handleChangePasswordOld}
                          />
                          <div
                            className="PasswordEye"
                            onClick={handlePasswordClick}
                          >
                            {passwordEye === false ? (
                              <HidePassword />
                            ) : (
                              <ShowPassword />
                            )}
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      container
                      spacing={3}
                      className="gen-info-form grid-new"
                      // component={"form"}
                    ></Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="new-password">
                          New Password
                        </Typography>
                        <div className="ProfilePasswordEye">
                          <input
                            className="input-acg"
                            type={
                              passwordEyeNew === false ? "password" : "text"
                            }
                            value={newpassword}
                            onChange={handleChangePasswordNew}
                            id="new-password"
                          />
                          <div
                            className="PasswordEye"
                            onClick={handlePasswordNewClick}
                          >
                            {passwordEyeNew === false ? (
                              <HidePassword />
                            ) : (
                              <ShowPassword />
                            )}
                          </div>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography
                          xs={12}
                          component={"label"}
                          htmlFor="verify-password"
                        >
                          Verify Password
                        </Typography>
                        <div className="ProfilePasswordEye">
                          <input
                            className="input-acg"
                            type={
                              passwordEyeVerify === false ? "password" : "text"
                            }
                            value={confnewpassword}
                            onChange={handleChangePasswordNewConf}
                            id="verify-password"
                          />
                          <div
                            className="PasswordEye"
                            onClick={handlePasswordVerifyClick}
                          >
                            {passwordEyeVerify === false ? (
                              <HidePassword />
                            ) : (
                              <ShowPassword />
                            )}
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <StyledFilledButton
                      sx={{ marginLeft: "auto", marginTop: "20px" }}
                      type="submit"
                      onClick={handleSubmitPassword}
                    >
                      Update Password
                    </StyledFilledButton>
                  </Grid>
                </div>
              )}
              {/* Account Setting starts here */}
              {profileActive === 3 && (
                <div className="DpboxCon">
                  <div className="DpboxCon-Top myp">
                    <div className="profileTop-c">Account Setting</div>
                  </div>
                  <Grid
                    container
                    item
                    onSubmit={handleAccountSubmit}
                    className="gen-info-form"
                    component={"form"}
                    spacing={3}
                  >
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="username">
                          Username
                        </Typography>
                        <input
                          disabled
                          type="text"
                          value={email}
                          className="input-acg"
                          onChange={handleChangeEmail}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography
                          component={"label"}
                          htmlFor="Language-select"
                        >
                          Language
                        </Typography>
                        <Select
                          id="Language-select"
                          className="form-input-select input-acg"
                          value={selectedLanguage}
                          onChange={handleChangeLang}
                        >
                          <MenuItem value="English">English</MenuItem>
                          <MenuItem value="French">French</MenuItem>
                          <MenuItem value="Spanish">Spanish</MenuItem>
                        </Select>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-grp-in">
                        <Typography component={"label"} htmlFor="tz-select">
                          Time Zone
                        </Typography>
                        <Select
                          id="tz-select"
                          className="form-input-select input-acg"
                          value={timeZone}
                          onChange={handleChangeTZ}
                        >
                          <MenuItem value="IST">IST</MenuItem>
                          <MenuItem value="UTC">UTC</MenuItem>
                        </Select>
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} md={4}>
          <StyledFilledButton type="submit">
            Save changes
          </StyledFilledButton>
        </Grid> */}
                  </Grid>
                  <Grid
                    className="action-container"
                    md={2}
                    display={"flex"}
                    alignItems={{ md: "center", xs: "flex-start" }}
                    justifyContent={{ md: "space-between" }}
                    flexDirection={{ xs: "column", md: "row" }}
                    mt={"20px"}
                  >
                    <div
                      className="publicData_switch"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsChecked(!isChecked)}
                      >
                        {isChecked ? (
                          <img
                            src={checkbox}
                            alt=""
                            className="profile-checkbox"
                          />
                        ) : (
                          <img src={checkboxChecked} alt="" />
                        )}
                        <Typography
                          htmlFor="checkbox"
                          style={{ marginLeft: "10px", textWrap: "nowrap" }}
                        >
                          Publicly accessible data
                        </Typography>
                      </div>
                    </div>
                    <Grid item xs={12} md={4}>
                      <StyledFilledButton
                        variant="outlined"
                        color="error"
                        sx={{ marginLeft: "auto", marginTop: "0px" }}
                        type="submit"
                        className="delete_button"
                      >
                        Delete Account
                      </StyledFilledButton>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "20px",
                    }}
                  >
                    {/* <div
          className="switch-wrapper"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography style={{ color: "#ffff" }}>
            Publically accessable data
          </Typography>
          <FormControlLabel
            control={<IOSSwitch sx={{ m: 2 }} defaultChecked />}
          />
        </div>
        <div>
          <Typography
            style={{
              color: "#FD504F",
              textDecorationLine: "underline",
              cursor: "pointer",
            }}
          >
            Delete account
          </Typography>
        </div> */}
                  </Grid>
                </div>
              )}
            </div>
          </div>
        )}

        {mainTabination === 2 && (
          <>
            <Grid2
              container
              item
              className="verification-ctn gen-info-form"
              spacing={3}
              sx={{ margin: "auto", paddingBottom: "20px" }}
            >
              <Grid2
                className="verification-options"
                item
                xs={12}
                md={3}
                lg={3}
              >
                <div className="form-grp-in">
                  <div className="container-box">
                    <div className="container-item">
                      {/* <img src={generateIcon} alt="generateIcon" /> */}
                      <div className="generateIcon">
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="40" height="40" rx="20" fill="#121418" />
                          <path
                            d="M13.9319 13.3869L13.7495 14.1144L13.9319 13.3869ZM17.3064 11.4386L16.5852 11.2328L17.3064 11.4386ZM11.2384 18.0522L11.7772 17.5305L11.2384 18.0522ZM11.2384 21.9488L10.6995 21.4271H10.6995L11.2384 21.9488ZM13.9319 26.6141L14.1142 27.3416L13.9319 26.6141ZM17.3064 28.5624L16.5852 28.7682L17.3064 28.5624ZM22.6935 28.5624L23.4147 28.7682L22.6935 28.5624ZM26.068 26.6141L26.2504 25.8866L26.068 26.6141ZM28.7615 21.9488L28.2227 22.4705V22.4705L28.7615 21.9488ZM28.7615 18.0522L28.2227 17.5305V17.5305L28.7615 18.0522ZM26.068 13.3869L25.8857 12.6594L26.068 13.3869ZM22.6935 11.4386L23.4147 11.2328L22.6935 11.4386ZM13.7495 14.1144C15.6084 14.5804 17.5017 13.4873 18.0276 11.6444L16.5852 11.2328C16.2815 12.2972 15.1879 12.9285 14.1142 12.6594L13.7495 14.1144ZM11.7772 17.5305C10.342 16.048 11.748 13.6127 13.7495 14.1144L14.1142 12.6594C10.6489 11.7908 8.2146 16.0071 10.6995 18.5739L11.7772 17.5305ZM11.7772 22.4705C13.1102 21.0936 13.1102 18.9074 11.7772 17.5305L10.6995 18.5739C11.4694 19.3691 11.4694 20.6319 10.6995 21.4271L11.7772 22.4705ZM13.7495 25.8866C11.748 26.3883 10.342 23.953 11.7772 22.4705L10.6995 21.4271C8.2146 23.9939 10.6489 28.2102 14.1142 27.3416L13.7495 25.8866ZM18.0276 28.3566C17.5017 26.5137 15.6084 25.4207 13.7495 25.8866L14.1142 27.3416C15.1879 27.0725 16.2815 27.7038 16.5852 28.7682L18.0276 28.3566ZM21.9722 28.3566C21.406 30.3408 18.5939 30.3408 18.0276 28.3566L16.5852 28.7682C17.5656 32.2036 22.4342 32.2036 23.4147 28.7682L21.9722 28.3566ZM26.2504 25.8866C24.3915 25.4207 22.4982 26.5137 21.9722 28.3566L23.4147 28.7682C23.7184 27.7038 24.812 27.0725 25.8857 27.3416L26.2504 25.8866ZM28.2227 22.4705C29.6579 23.953 28.2519 26.3883 26.2504 25.8866L25.8857 27.3416C29.351 28.2102 31.7853 23.9939 29.3004 21.4271L28.2227 22.4705ZM28.2227 17.5305C26.8897 18.9074 26.8897 21.0936 28.2227 22.4705L29.3004 21.4271C28.5305 20.6319 28.5305 19.3691 29.3004 18.5739L28.2227 17.5305ZM26.2504 14.1144C28.2519 13.6127 29.6579 16.048 28.2227 17.5305L29.3004 18.5739C31.7853 16.0071 29.351 11.7908 25.8857 12.6594L26.2504 14.1144ZM21.9722 11.6444C22.4982 13.4873 24.3915 14.5804 26.2504 14.1144L25.8857 12.6594C24.812 12.9285 23.7184 12.2972 23.4147 11.2328L21.9722 11.6444ZM23.4147 11.2328C22.4342 7.7974 17.5656 7.79741 16.5852 11.2328L18.0276 11.6444C18.5939 9.66019 21.406 9.66019 21.9722 11.6444L23.4147 11.2328ZM16.2499 20.0005C16.2499 22.0716 17.9289 23.7505 19.9999 23.7505V22.2505C18.7573 22.2505 17.7499 21.2431 17.7499 20.0005H16.2499ZM19.9999 23.7505C22.071 23.7505 23.7499 22.0716 23.7499 20.0005H22.2499C22.2499 21.2431 21.2426 22.2505 19.9999 22.2505V23.7505ZM23.7499 20.0005C23.7499 17.9294 22.071 16.2505 19.9999 16.2505V17.7505C21.2426 17.7505 22.2499 18.7579 22.2499 20.0005H23.7499ZM19.9999 16.2505C17.9289 16.2505 16.2499 17.9294 16.2499 20.0005H17.7499C17.7499 18.7579 18.7573 17.7505 19.9999 17.7505V16.2505Z"
                            fill="#8F8F8F"
                          />
                        </svg>
                      </div>
                      <Typography className="container-text">
                        Billing
                      </Typography>
                    </div>
                    {/* <hr className="breakline"></hr> */}
                    {/* <div className="container-item">
                      <img src={requestIcon} alt="requestIcon" />
                      <Typography className="container-text">
                        Request to change
                      </Typography>
                    </div> */}
                  </div>
                </div>
              </Grid2>

              <Grid2
                className="form-grp-in"
                item
                xs={12}
                md={8}
                lg={8}
                direction={"row"}
              >
                <Grid2 className=" container-box">
                  <Grid2 item xs={12}>
                    <div className="DpboxCon-Top myp">
                      <div className="profileTop-c">Payment Verification</div>
                    </div>
                  </Grid2>
                  <Grid2 className="bank-wrapper" container>
                    <Grid2
                      item
                      container
                      className="bank-list"
                      direction="row"
                      spacing={2}
                      xs={12}
                      md={7}
                      style={{ display: "flex", width: "100%" }}
                    >
                      <Grid2
                        container
                        item
                        xs={12}
                        sm={6}
                        spacing={2}
                        style={{
                          width: "fit-content",
                          opacity: "25%",
                          pointerEvents: "none",
                        }}
                      >
                        <div className="ver-card" style={{ width: "100%" }}>
                          <Grid2 item xs={2}>
                            <FormControl>
                              <RadioGroup
                                value={radioValue}
                                onChange={handleRadioChange}
                                onClick={handleRadioChange}
                              >
                                <FormControlLabel
                                  value="Deel"
                                  disabled={payment?.type === "Bank Wire"}
                                  control={
                                    <Radio
                                      name="Deel"
                                      checkedIcon={<BpCheckedIcon />}
                                      icon={<BpIcon />}
                                      disabled
                                      disableRipple
                                    />
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid2>
                          <Grid2 item xs={10}>
                            <img src={deelIcon} alt="deelIcon" width={"100%"} />
                          </Grid2>
                        </div>
                      </Grid2>

                      <Grid2
                        container
                        item
                        xs={6}
                        sm={6}
                        spacing={2}
                        style={{ width: "fit-content" }}
                      >
                        <div
                          id="RISE"
                          className="ver-card"
                          style={{ width: "100%" }}
                          onClick={handleRadioChange}
                        >
                          <Grid2 item xs={2}>
                            <div>
                              <FormControl>
                                <RadioGroup
                                  value={radioValue}
                                  // onChange={handleRadioChange}
                                  // onClick={handleRadioChange}
                                >
                                  <FormControlLabel
                                    value="RISE"
                                    // disabled={payment?.type === "Deel"}
                                    control={
                                      <Radio
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        disableRipple
                                        name="RISE"
                                        checked={payment?.type === "RISE"}
                                      />
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </Grid2>
                          <Grid2 item xs={10}>
                            <div>
                              <img
                                src={riseIcon}
                                alt="rise icon"
                                width={"100%"}
                                style={{ padding: "10%" }}
                              />
                            </div>
                          </Grid2>
                        </div>
                      </Grid2>

                      <Grid2
                        container
                        item
                        xs={6}
                        sm={6}
                        spacing={2}
                        style={{ width: "fit-content" }}
                      >
                        <div
                          id="WISE"
                          className="ver-card"
                          style={{ width: "100%" }}
                          onClick={handleRadioChange}
                        >
                          <Grid2 item xs={2}>
                            <div>
                              <FormControl>
                                <RadioGroup
                                  value={radioValue}
                                  // onChange={handleRadioChange}
                                  // onClick={handleRadioChange}
                                >
                                  <FormControlLabel
                                    value="WISE"
                                    // disabled={payment?.type === "Deel"}
                                    control={
                                      <Radio
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        disableRipple
                                        name="WISE"
                                        checked={payment?.type === "WISE"}
                                      />
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </Grid2>
                          <Grid2 item xs={10}>
                            <div>
                              <img
                                src={wiseIcon}
                                alt="wise icon"
                                width={"100%"}
                                style={{ padding: "10%" }}
                              />
                            </div>
                          </Grid2>
                        </div>
                      </Grid2>

                      <Grid2
                        container
                        item
                        xs={6}
                        sm={6}
                        spacing={2}
                        style={{ width: "fit-content" }}
                      >
                        <div
                          id="Bank Wire"
                          className="ver-card"
                          style={{ width: "100%" }}
                          onClick={handleRadioChange}
                        >
                          <Grid2 item xs={2}>
                            <div>
                              <FormControl>
                                <RadioGroup
                                  value={radioValue}
                                  // onChange={handleRadioChange}
                                  // onClick={handleRadioChange}
                                >
                                  <FormControlLabel
                                    value="Bank Wire"
                                    disabled={payment?.type === "Deel"}
                                    control={
                                      <Radio
                                        checkedIcon={<BpCheckedIcon />}
                                        icon={<BpIcon />}
                                        disableRipple
                                        name="Bank Wire"
                                        checked={payment?.type === "Bank Wire"}
                                      />
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </Grid2>
                          <Grid2 item xs={10}>
                            <div>
                              <img
                                src={bankWireIcon}
                                alt="bankWireIcon"
                                width={"100%"}
                                style={{ padding: "10%" }}
                              />
                            </div>
                          </Grid2>
                        </div>
                      </Grid2>
                    </Grid2>
                    {/* <Grid2 item xs={12} md={5}>
                    {isPaymentVerified ? (
                      <img src={paymentIcon} alt="paymentIcon" width={"100%"} />
                    ) : (
                      false
                    )}
                  </Grid2> */}
                  </Grid2>
                  {/* {isPaymentVerified ? (
                  <div className="pay-text">
                    <img src={verifiedIcon} alt="verifiedIcon" /> Verified
                  </div>
                ) : (
                  false
                )} */}

                  {isPaymentVerified ? (
                    <div className="pay-text">
                      <img src={badgeCompleteIcon} alt="Complete" />
                      <p>
                        Payment Process Verified -{" "}
                        <span className="badgeApproved">
                          Your Payment Method has been completed
                        </span>
                      </p>
                    </div>
                  ) : payment?.data?.deel_email ? (
                    <>
                      {
                        <div className="pay-text">
                          {/* <img src={badgeErrorIcon} alt="Error" /> */}
                          <p>
                            <span className="badgeReview">
                              Your Payment Process is under review.{" "}
                            </span>
                            {/* <span
                              className="link"
                              onClick={handlePaymentTryAgain}
                            >
                              Try Again
                            </span> */}
                          </p>
                        </div>
                      }
                      {/* (
                    <>
                      {processError.paymentProcess && (
                        <div className="pay-text">
                          <img src={badgeErrorIcon} alt="Error" />
                          <p>
                            Payment Method Rejected -{" "}
                            <span className="badgeError">
                              Your Payment Process has been failed.{" "}
                            </span>
                            <span
                              className="link"
                              onClick={handlePaymentTryAgain}
                            >
                              Try Again
                            </span>
                          </p>
                        </div>
                      )}
                    </>
                  ) */}
                    </>
                  ) : (
                    false
                  )}
                </Grid2>
              </Grid2>
              <Grid2
                className="kyc-verification-container"
                item
                xs={12}
                md={8}
                mdOffset={3}
                lg={8}
                lgOffset={3}
              >
                <div className="form-grp-in">
                  <div className="container-box" style={{ padding: "20px" }}>
                    <div className="DpboxCon-Top myp">
                      <div className="profileTop-c">KYC Verification</div>
                    </div>
                    <Grid2
                      className="kyc-options-container"
                      container
                      style={{ justifyContent: "space-between" }}
                    >
                      <Grid2 item xs={12} md={4} className="pay-container">
                        {/* <FormControl>
                          <RadioGroup value={sumsubRadio}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              value={sumsubRadio}
                              control={
                                <Radio
                                  checkedIcon={<BpCheckedIcon />}
                                  icon={<BpIcon />}
                                  disableRipple
                                  value={"veriff"}
                                />
                              }
                            />
                          </RadioGroup>
                        </FormControl> */}
                        <img width="150px" src={veriffLogo} alt="veriff icon" />
                        {/* <Typography className="kyc-text">VERIFF</Typography> */}
                      </Grid2>
                      
                      {!isKycVerified && (
                        <Grid2
                          item
                          xs={6}
                          md={3}
                          className={"verify-button pay-container"}
                        >
                          <CustomLoadingButton
                            onClick={getKYCLink}
                            loading={kycLoading}
                            disabled={
                              isKycVerified ||
                              kycLoading ||
                              (kyc?.data && kyc.data?.status === "pending")
                            }
                            text={
                              isKycVerified
                                ? "No action req."
                                : kyc?.data && kyc.data?.status === "pending"
                                ? "Under review"
                                : false
                            }
                            endIcon={false}
                          />
                        </Grid2>
                      )}
                      {/* <Grid2
                        item
                        xs={12}
                        md={5}
                        className={
                          !isKycVerified ? "verify-button" : "pay-container"
                        }
                      >
                        {isKycVerified ? (
                          <img
                            src={protectIcon}
                            alt="protectIcon"
                            style={{ marginLeft: "5%" }}
                            width={"100%"}
                          />
                        ) : (
                          false
                        )}
                      </Grid2> */}
                    </Grid2>
                    <div className="pay-text">
                      {isKycVerified ? (
                        <>
                          <img src={badgeCompleteIcon} alt="" />
                          <p>
                            {/* Account Verified -{" "} */}
                            <span className="badgeApproved">
                              Your KYC has been completed
                            </span>
                            <div>
                              We will reach out if further information is
                              required
                            </div>
                          </p>
                        </>
                      ) : (
                        <>
                          {processError.kycProcess && (
                            <div className="pay-text">
                              <img src={badgeErrorIcon} alt="Error" />
                              <p>
                                Account Rejected -{" "}
                                <span className="badgeError">
                                  KYC Verification has been failed.{" "}
                                </span>
                                <span className="link" onClick={getKYCLink}>
                                  Try Again
                                </span>
                              </p>
                            </div>
                          )}
                          {kyc?.data && kyc.data?.status === "pending" ? (
                            <div className="pay-text">
                              <img src={badgeErrorIcon} alt="Error" />
                              <p>
                                <span className="badgeReview">
                                  KYC Verification is under review.{" "}
                                </span>
                                {/* <span className="link" onClick={()=>getKYCLink(true)}>
                                  Try Again
                                </span> */}
                              </p>
                            </div>
                          ) : (
                            false
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </Grid2>
              {isKycVerified && !claimStatus ? (
                <Grid2 item xs={12} md={8} mdOffset={3} lg={8} lgOffset={3}>
                  <div className="form-grp-in">
                    <div className="container-box" style={{ padding: "20px" }}>
                      <div className="DpboxCon-Top myp"></div>
                      <Grid2
                        container
                        style={{ justifyContent: "space-between" }}
                      >
                        <Grid2 item xs={12} md={4} className="pay-container">
                          <Typography
                            sx={{ color: "#ffffff" }}
                            className="kyc-text"
                          >
                            Claim Your 5K Account
                          </Typography>
                        </Grid2>
                        <Grid2
                          item
                          xs={6}
                          md={3}
                          className={
                            !isKycVerified ? "verify-button" : "pay-container"
                          }
                        >
                          {/* Verify Button */}
                          <CustomLoadingButton
                            onClick={handleClaim}
                            loading={claimLoading}
                            disabled={claimLoading}
                            text={"Claim"}
                            endIcon={false}
                          />
                        </Grid2>

                        <ErrorPopup
                          trigger={errorPopupVisible}
                          setTrigger={setErrorPopupVisible}
                          head="Claim Error"
                          subhead={errorMsg}
                          onClick={(e) => {
                            setErrorPopupVisible(false);
                          }}
                        />
                      </Grid2>
                    </div>
                  </div>
                </Grid2>
              ) : (
                ""
              )}

              {!isContractIssued ? (
                <></>
              ) : (
                <Grid2
                  className="contact-signature"
                  item
                  xs={12}
                  md={8}
                  mdOffset={3}
                  lg={8}
                  lgOffset={3}
                >
                  <div className="form-grp-in">
                    <div className="container-box" style={{ padding: "20px" }}>
                      <div className="DpboxCon-Top myp">
                        <div className="profileTop-c contract-sign-wrapper">
                          Contract signature
                          <img src={digiSignerIcon} alt="" className="" />
                        </div>

                        <Link
                          style={{ textDecoration: "none" }}
                          to="/docusign/get_signing_url/"
                          className="verifiy-digiSigner"
                        >
                          <StyledFilledButton
                            style={{ width: "250px" }}
                            disabled
                          >
                            Sign
                          </StyledFilledButton>
                        </Link>

                        {/* <div>Please check back in 48hrs for an update to this section. Any urgent support required , email to <a href="mailto:support@alphacapitalgroup.uk">support@alphacapitalgroup.uk</a></div> */}
                      </div>
                    </div>
                  </div>
                </Grid2>
              )}
            </Grid2>
            {open && (
              <BankWireModal
                open={open}
                modalClose={handleClose}
                country={country}
                contryCodeArray={contryCodeArray}
                city={city}
                handleSelectChange={handleSelectChange}
              />
            )}
            {deelOpen && (
              <DeelModal open={deelOpen} deelmodalClose={deelHandleClose} />
            )}
            {riseOpen && (
              <RiseModal
                open={riseOpen}
                risemodalClose={riseHandleClose}
                defaultEmail={
                  payment?.type === "RISE" ? payment.data?.rise_email : ""
                }
              />
            )}
            {wiseOpen && (
              <WiseModal
                open={wiseOpen}
                wisemodalClose={wiseHandleClose}
                defaultEmail={
                  payment?.type === "WISE" ? payment.data?.wise_email : ""
                }
              />
            )}
          </>
        )}
        {mainTabination === 3 && (
          <>
            {!requestPayout ? (
              <>
                <div
                  className="DpboxCon"
                  style={{ marginTop: "24px", border: 0, padding: 0 }}
                >
                  <Typography
                    className="payout-heading"
                    style={{ marginBottom: "2%" }}
                  >
                    Welcome to my Payout
                  </Typography>
                  <Typography className="payout-subHeading"></Typography>
                </div>
                <Grid2
                  container
                  item
                  className="gen-info-form"
                  spacing={0}
                  width={"100%"}
                >
                  <Grid2
                    item
                    xs={12}
                    md={12}
                    lg={9}
                    gap={"20px"}
                    display={"flex"}
                  >
                    <div className="form-grp-in" style={{ width: "100%" }}>
                      <Grid2
                        container
                        className="container-box"
                        style={{
                          padding: "20px",
                          display: "flex",
                          flexDirection: "row",
                          // marginBottom: "10px",
                          height: "100%",
                        }}
                        xs={12}
                        md={11.7}
                      >
                        <Grid2 item xs={12} md={7}>
                          <Typography className="payout-heading">
                            Ready to request Your Payout
                          </Typography>
                          <Typography className="payout-subHeading">
                            Please click on the request payout button and
                            proceed to fill out the needed information; our
                            staff will contact you for further developments.
                            <br></br>
                            <br></br>
                            <div
                              className="payout-subHeading"
                              style={{ color: "#3EAFFF" }}
                            >
                              Note: Please wait for at least 15mins after you
                              close your latest trade to request a payout.
                            </div>
                          </Typography>
                        </Grid2>
                        <Grid2
                          item
                          xs={12}
                          md={5}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "20px",
                          }}
                        >
                          <Button
                            onClick={() => {
                              setRequestPayout(true);
                            }}
                            className="payout-button"
                            style={{
                              color: "#ffffff",
                              background: "#04D9FF",
                            }}
                            endIcon={<ArrowRightAltIcon fontSize="medium" />}
                          >
                            Request Payout
                          </Button>
                        </Grid2>
                      </Grid2>
                    </div>
                  </Grid2>
                  <Grid2 item xs={12} md={3} lg={3}>
                    {/* <div className="form-grp-in" style={{ height: "100%" }}>
                      <a
                        style={{ textDecoration: "none", height: "100%" }}
                        href="https://discord.com/invite/W5aKKmPRdR"
                      >
                        <div
                          style={{ height: "100%" }}
                          className="add-container"
                        >
                          <Typography className="add-text">
                            December 2023<br></br>
                            Trading<br></br> Competition
                          </Typography>
                          <Button
                            className="payout-button"
                            style={{
                              background: "#04d9ff",
                              marginTop: "7%",
                              color: "#fff",
                            }}
                          >
                            Enter Competition
                          </Button>
                        </div>
                      </a>
                    </div> */}
                    <AdsComponent variant="small" />
                  </Grid2>
                </Grid2>
                <div
                  className=" LeaderboardPage PaymentHistoryPage mtt-20 historyDeskPayment"
                  style={{ width: "100%" }}
                >
                  {!isMobile ? (
                    <div className="HistoryDesk">
                      <ReactBootstrap.Table className="LeaderboardTable">
                        <thead>
                          <tr>
                            <th>#Id</th>
                            <th>
                              Payout Type{" "}
                              <Select input={<SelectTable />}>
                                <MenuItem value="">1</MenuItem>
                                <MenuItem value="">2</MenuItem>
                                <MenuItem value="">3</MenuItem>
                              </Select>
                            </th>
                            <th>
                              Requested on{" "}
                              <Select input={<SelectTable />}>
                                <MenuItem value="">1</MenuItem>
                                <MenuItem value="">2</MenuItem>
                                <MenuItem value="">3</MenuItem>
                              </Select>
                            </th>
                            <th>
                              Method{" "}
                              <Select input={<SelectTable />}>
                                <MenuItem value="">1</MenuItem>
                                <MenuItem value="">2</MenuItem>
                                <MenuItem value="">3</MenuItem>
                              </Select>
                            </th>
                            <th>
                              Status{" "}
                              <Select input={<SelectTable />}>
                                <MenuItem value="">1</MenuItem>
                                <MenuItem value="">2</MenuItem>
                                <MenuItem value="">3</MenuItem>
                              </Select>
                            </th>
                            <th>
                              Amount{" "}
                              <Select input={<SelectTable />}>
                                <MenuItem value="">1</MenuItem>
                                <MenuItem value="">2</MenuItem>
                                <MenuItem value="">3</MenuItem>
                              </Select>
                            </th>
                            <th>Invoices</th>
                          </tr>
                        </thead>
                        <tbody>
                          {payout_list.map((item) => (
                            <tr>
                              <td>{item.id}</td>
                              <td style={{ color: "#3eafff" }}>{item.type}</td>
                              <td>{formatDateTime(item.created_at)}</td>
                              <td>{item.method}</td>
                              <td>
                                {StatFormatter(
                                  String(item?.status).toLowerCase()
                                )}
                              </td>
                              <td>{dollarUS(item.amount)}</td>
                              <td>
                                {item.invoice ? (
                                  <a
                                    href={item.invoice}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <i>
                                      <DownloadRoundedIcon className="historyDesk-downloadButton"/>
                                    </i>
                                  </a>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </ReactBootstrap.Table>
                    </div>
                  ) : (
                    false
                  )}
                  {isMobile ? (
                    <div className="Historymobile">
                      {payout_list.map((item) => (
                        <div className="Box mbb-10">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gapp-10">
                              <Title four>{item.id}</Title>
                              <div className="Date">
                                {formatDateTime(item.created_at)}
                              </div>
                            </div>
                            <div
                            // style={{
                            //   display: "flex",
                            //   flexDirection: "row-reverse",
                            //   gap: "1rem",
                            // }}
                            >
                              <img src={downloadIcon} alt="" />
                              {StatFormatter(
                                String(item?.status).toLowerCase()
                              )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between mtt-20 BoxS">
                            <HeadAndDesc
                              HeadTitle="Payout Type"
                              SubTitle={item.type}
                            />
                            <HeadAndDesc
                              // SubTitleClass="paymentTD"
                              HeadTitle="Method"
                              SubTitle={item.method}
                            />
                            <HeadAndDesc
                              HeadTitle="Amount"
                              SubTitle={dollarUS(item.amount)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    false
                  )}
                </div>
              </>
            ) : (
              <RequestPayout close={setRequestPayout} />
            )}
          </>
        )}
      </Box>
    </div>
  );
};

export default Profile;
